/** Default link targets for Puck templates and fallback pages (override per tenant in the editor). */
export const TEMPLATE_DEFAULT_URLS = {
  home: '/',
  signIn: '/sign-in',
  signUp: '/sign-up',
  learningPath: '/learning-path',
  myCourses: '/my-courses',
  curriculumAnchor: '#course-path',
} as const

/** Enroll / đăng ký CTAs route to my courses on community sites. */
export function isEnrollCtaLabel(buttonText: string): boolean {
  const normalized = buttonText.trim().toLowerCase()
  return normalized === 'enroll now' || normalized === 'đăng ký ngay'
}
